"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var TypeCounter = function TypeCounter(_ref) {
  var icon = _ref.icon,
      value = _ref.value;
  return value ? /*#__PURE__*/_react.default.createElement("div", {
    className: 'user-select-none margin-right-15'
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "rioglyph rioglyph-".concat(icon, " text-size-16")
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: 'TreeLabelCount margin-left-3 label label-muted label-filled label-condensed'
  }, value)) : null;
};

TypeCounter.propTypes = {
  icon: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node, _propTypes.default.number])
};
var _default = TypeCounter;
exports.default = _default;